import React from "react";
import * as s from "./PDFDownloadBlock.module.css";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import { webhookEvents, formValidation } from "../../../utils/webhookService";

const PDFDownloadBlock = ({ block, post }) => {

  const [firstName, setFirstName] = React.useState("");
  const [lastName, setLastName] = React.useState("");

  const [email, setEmail] = React.useState("");
  const [acceptChecked, setAcceptChecked] = React.useState(false);
  const [errors, setErrors] = React.useState({
    firstName: null,
    lastName: null,
    email: null,
  });
  const desktopImage = {
    data: block.desktopImage?.localFile?.childImageSharp?.gatsbyImageData,
    alt: block.desktopImage?.alt || ``,
  };
  const mobileImage = {
    data: block.mobileImage?.localFile?.childImageSharp?.gatsbyImageData,
    alt: block.mobileImage?.alt || ``,
  };
  const [messageSent, setMessageSent] = React.useState(false);

  const handleAcceptCheckboxChange = (e) => {
    setAcceptChecked(e.target.checked);
  }

  const submitForm = (e) => {
    if (isValidForm()) {
      setMessageSent(true);

      const formData = {
        firstName: firstName,
        lastName: lastName,
        email: email,
        post: post,
      };

      // Use the standardized webhook service
      webhookEvents.pdfDownload(formData, {
        onSuccess: () => {
          // Reset form fields
          setFirstName("");
          setLastName("");
          setEmail("");
          setErrors({
            firstName: null,
            lastName: null,
            email: null,
          });
          setMessageSent(true);
        },
        onError: (error) => {
          console.error("PDF Download form submission failed:", error);
          setMessageSent(false); // Reset message sent state on error
        }
      });

      // Download the PDF file
      const element = document.createElement("a");
      element.href = block?.file?.localFile?.publicURL;
      element.download = block?.file?.localFile?.base;
      element.click();
    }
  }

  const isValidForm = () => {
    const fields = { firstName, lastName, email };
    const validationRules = {
      firstName: {
        required: true,
        notEmpty: true,
        requiredMessage: 'Please enter Your First Name'
      },
      lastName: {
        required: true,
        notEmpty: true,
        requiredMessage: 'Please enter Your Last Name'
      },
      email: {
        required: true,
        email: true,
        requiredMessage: 'Please enter a valid Email'
      }
    };

    const { isValid, errors } = formValidation.validateRequiredFields(fields, validationRules);
    setErrors(errors);
    return isValid;
  }

  if (block?.show) {
    return (
      <div className={`${s.pdfDownloadBlock}`}>
        <div className='container px-0'>
          <div className='row mx-0'>
            <div className='col-lg-6 ps-lg-0'>
              <div className="imageWrapper position-relative">
                {!!desktopImage?.data ? (
                  <GatsbyImage
                    placeholder="none"
                    loading="eager"
                    image={desktopImage.data}
                    alt={desktopImage.alt}
                    className={`${s.desktopImage} d-none d-lg-block position-absolute`}
                  />
                ) : <StaticImage
                  quality={100}
                  placeholder="none"
                  loading="eager"
                  className={`${s.desktopImage} d-none d-lg-block position-absolute`}
                  alt="form image"
                  src="./desktop.png" />}

                {!!mobileImage?.data ? (
                  <GatsbyImage
                    placeholder="none"
                    loading="eager"
                    image={mobileImage.data}
                    alt={mobileImage.alt}
                    className={`d-lg-none ${s.mobileImage}`}
                  />
                ) : <StaticImage
                  quality={100}
                  placeholder="none"
                  loading="eager"
                  className={`d-lg-none ${s.mobileImage}`}
                  alt="form image"
                  src="./mobile.png" />}

              </div>
            </div>
            <div className='col-lg-6 pe-lg-0 mt-4 mt-lg-0'>
              <div className="row">
                <div className="col-lg-12">
                  <h3 className={s.title}>Receive Actionable Tips Immediately!</h3>
                </div>
                <div className="col-lg-12">
                  <div className={`${s.labelInputGroup}`}>
                    <div className={s.inputWrapper}>
                      <label>First Name</label>
                      <input
                        className={`${null != errors.firstName && s.invalid}`}
                        type="text"
                        name="firstname"
                        value={firstName}
                        onChange={e => setFirstName(e.target.value)}
                      />
                      {/* {null != errors.firstName && <small style={{ color: 'red' }}>{errors.firstName}</small>} */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className={`${s.labelInputGroup}`}>
                    <div className={s.inputWrapper}>
                      <label>Last Name</label>
                      <input
                        className={`${null != errors.lastName && s.invalid}`}
                        type="text"
                        name="lastname"
                        value={lastName}
                        onChange={e => setLastName(e.target.value)}
                      />
                      {/* {null != errors.lastName && <small style={{ color: 'red' }}>{errors.lastName}</small>} */}
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className={`${s.labelInputGroup} w-100`}>
                    <div className={s.inputWrapper}>
                      <label>Email</label>
                      <input
                        className={`${null != errors.email && s.invalid}`}
                        type="email"
                        name="email"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                      />
                      {/* {null != errors.email && <small style={{ color: 'red' }}>{errors.email}</small>} */}
                    </div>
                  </div>
                </div>



                <div className="col-12">
                  <label className={`${s.labelCheckboxGroup} w-100`}>
                    <input type="checkbox" onChange={handleAcceptCheckboxChange} />
                    I have read and accept the &nbsp;<a href="/privacy-policy" target="_blank"> Privacy Policy</a>.
                  </label>
                </div>
                <div className="col-12">
                  <button type="submit" disabled={!acceptChecked} className={`${s.sendButton}`} onClick={submitForm}>
                    Download PDF
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

      </div>
    );
  }
  return <></>
};

export default PDFDownloadBlock;
